/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MarketShoppingCartIcon20Solid = forwardRef('MarketShoppingCartIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M0 3a1 1 0 0 1 1-1h2.31a2.5 2.5 0 0 1 2.45 2h12.074c1 0 1.72.959 1.44 1.918l-1.426 4.918A3 3 0 0 1 14.967 13H7.712a3 3 0 0 1-2.964-2.537l-.827-5.29a.965.965 0 0 1-.005-.034l-.112-.716A.5.5 0 0 0 3.31 4H1a1 1 0 0 1-1-1Z" }),
        React.createElement("path", { d: "M7 14a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z" }),
        React.createElement("path", { d: "M15 14a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z" })));
});
